var _defs, _path, _path2, _circle, _circle2, _circle3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10068IconServicePublicIpAddressesClassic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ad83bb93-39a1-4a0a-bb3f-2a7b7dbaf4fb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a73b79b8-c434-4cf3-819a-3c2f2126c264",
    x1: 9,
    y1: 15.7,
    x2: 9,
    y2: 5.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#32caea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#32d2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32d4f5"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-networking-68") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5,5.66h17a0,0,0,0,1,0,0v9.48a.57.57,0,0,1-.57.57H1.07a.57.57,0,0,1-.57-.57V5.66A0,0,0,0,1,.5,5.66Z",
    fill: "url(#a73b79b8-c434-4cf3-819a-3c2f2126c264)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07,2H16.93a.57.57,0,0,1,.57.57V5.66a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V2.6A.57.57,0,0,1,1.07,2Z",
    fill: "#0078d4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.82,
    cy: 10.06,
    r: 1.38,
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.06,
    cy: 10.06,
    r: 1.38,
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.18,
    cy: 10.06,
    r: 1.38,
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.79,
    y: 3.12,
    width: 12.43,
    height: 1.46,
    rx: 0.28,
    fill: "#f2f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10068IconServicePublicIpAddressesClassic);
export default __webpack_public_path__ + "static/media/10068-icon-service-Public-IP-Addresses-(Classic).e2d1265e98f5ec6d5b2f3f08ec99ed2e.svg";
export { ForwardRef as ReactComponent };